export const styles = theme => ({
    banner: {
        position: "fixed" as const,
        bottom: 0,
        backgroundColor: "#e6e6e6",
        zIndex: 9999,
        minHeight: 167,
        width: "100%"
    },
    content: {
        padding: "10px 20px 20px 20px",
    },
    buttons: {
        paddingLeft: 20,
        margin: 0,
        listStyleType: "none",
    },
    checkbox: {
        marginLeft: 10,
    },
    text: {
        padding: 20,
    },
    minimized: {
        position: "fixed" as const,
        bottom: -4,
        left: 20,
        backgroundColor: "#e6e6e6",
        zIndex: 999,
        cursor: "pointer",
        padding: "5px 10px 5px 10px",
        //borderTopLeftRadius: 10,
        //borderTopRightRadius: 10,
        boxShadow: "2px -1px 8px 0 rgb(0 0 0 / 20%)",
        border: "1px lightgrey solid",
        "&:hover": {
            transform: "translateY(-4px)",
        }
    }
});